import api from './api';

export const fieldOperationsService = {
  async getFieldOperations(params = {}) {
    try {
      const response = await api.get('/cultural-operations', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch cultural operations');
    }
  },

  async getFieldOperation(id) {
    try {
      const response = await api.get(`/cultural-operations/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch cultural operation');
    }
  },

  async createFieldOperation(data) {
    try {
      const response = await api.post('/cultural-operations', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create cultural operation');
    }
  },

  async updateFieldOperation(id, data) {
    try {
      const response = await api.put(`/cultural-operations/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update cultural operation');
    }
  },

  async deleteFieldOperation(id) {
    try {
      const response = await api.delete(`/cultural-operations/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete cultural operation');
    }
  },

  async searchFieldOperations(query) {
    try {
      const response = await api.get('/cultural-operations', { 
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to search cultural operations');
    }
  },

  async getFieldOperationsByType(type) {
    try {
      const response = await api.get('/cultural-operations', { 
        params: { type }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch cultural operations by type');
    }
  },

  async getFieldOperationsByStatus(status) {
    try {
      const response = await api.get('/cultural-operations', { 
        params: { status }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch cultural operations by status');
    }
  },

  async getCulturalOperations(params = {}) {
    try {
      const response = await api.get('/cultural-operations', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch cultural operations');
    }
  }
};
